import { useContext } from "react";
import { GlobalContext, GlobalContextType } from "./GlobalContextProvider";

export function useDatacatalogContext() {
  const { datacatalog } = useContext<GlobalContextType>(GlobalContext);
  return datacatalog;
}
